<template>
    <v-dialog v-model="dialog" max-width="450" persistent>
      <v-card>
        <v-card-title class="text-h5">Add Category</v-card-title>
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="category.name"
                name="name"
                id="name"
                label="Name"
                v-validate="'required'"
                :error="errors.first('name') || serverSideErrors.name"
                :error-messages="errors.first('name') || serverSideErrors.name"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="saveCategory">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { mapMutations } from 'vuex';
  
  export default {
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        category: {},
        serverSideErrors: {},
      };
    },
    methods: {
      ...mapMutations('alert', ['setAlert']),
      closeDialog() {
        this.$emit('update:dialog', false);
        this.$validator.reset();
        this.category = {};
      },
      saveCategory() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$axios.post('societyadmin/categories', { name: this.category.name }).then((response) => {
              const data = response.data;
              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  variant: 'success accent-3',
                  timeout: 2000,
                  message: data.message,
                });
                this.$emit('category-added', data.category);
                this.closeDialog();
              } else {
                this.serverSideErrors = {};
                if (data.errors) {
                  data.errors.forEach((error) => {
                    this.serverSideErrors[error.field] = error.message;
                  });
                } else {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: 'red accent-3',
                    timeout: 2000,
                  });
                }
              }
            });
          }
        });
      },
    },
  };
  </script>
  